import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { useUi } from "@/context/UiContext";

const CONTENTS = [
  { icon: "ri-play-circle-line", label: "精選影音", note: "內容即將上線" },
  { icon: "ri-message-3-line", label: "社群內容", note: "內容即將上線" },
  { icon: "ri-calendar-line", label: "最新講座", note: "內容即將上線" },
];

export default function AiSection() {
  const { openAi } = useUi();

  return (
    <section className="bg-cream">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-6">
            <Reveal>
              <SectionHeading
                eyebrow="AI 幸福人才顧問"
                title="有些問題，可以先從一段對話開始。"
              />
              <p className="mt-6 text-base leading-[1.85] text-ink-soft reading-width">
                如果你現在還不知道自己真正卡在哪裡、適合哪一個課程，
                或幸福人才的方法和你的問題有沒有關係，可以先和 AI 幸福人才顧問聊聊。
              </p>
              <div className="mt-8">
                <Button onClick={openAi} icon="ri-arrow-right-line">
                  和 AI 幸福人才顧問聊聊
                </Button>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={100}>
              <div className="rounded-card bg-white border border-line p-7 md:p-8">
                <p className="text-sm font-semibold text-ink-soft">最新內容</p>
                <div className="mt-5 space-y-3">
                  {CONTENTS.map((c) => (
                    <div
                      key={c.label}
                      className="flex items-center gap-4 rounded-md border border-line p-4"
                    >
                      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-gold-soft/70">
                        <i className={`${c.icon} text-lg text-primary`} aria-hidden="true"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-ink">{c.label}</p>
                      </div>
                      <span className="text-xs text-ink-soft/60">{c.note}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}